<template>
  <div class="m-map">
    <div class="amap-marker-label" v-if="showDetails" :style="{left:nLeft+'px',top:nTop+'px'}">
      <div class="tipHover">
        <div class="th1">
          <span
            @click="goCity(hCityDetails[0].cityName,hCityDetails[0].cityCode)"
          >{{hCityDetails[0].cityName}}</span>
          <i class="el-icon-caret-right">
            <i class="el-icon-caret-right el-icon-caret-right1"></i>
          </i>
          <i @click="closeDetails" class="el-icon-close el-icon-close12"></i>
        </div>
        <div class="th2">
          <div>
            {{ hCityDetails[0].operationsRange}}
            <p>
              运营车次
              <br />（日均）
            </p>
          </div>
          <div>
            {{hCityDetails[0].gasStationRange}}
            <p>
              加油站停靠
              <br />（日均）
            </p>
          </div>
          <div>
            {{hCityDetails[0].logisticsPark}}
            <p>
              物流园停靠
              <br />（日均）
            </p>
          </div>
          <div>
            {{hCityDetails[0].density}}
            <p>加油站密度</p>
          </div>
          <div>
            {{hCityDetails[0].lugNumber }}
            <p>
              LNG车次
              <br />（日均）
            </p>
          </div>
        </div>
      </div>
    </div>
    <p
      class="m-tip"
    >{{isShowHotCity?'2018年'+hotZoneAreas[0].cityName+'公路运营热力图':'2018年度全国城市公路运营热力图'}}</p>
    <div id="js-container" class="map">正在加载数据 ...</div>
  </div>
</template>
<script>
import remoteLoad from './remoteLoad.js'
import axios from '@/api/road.js'
import commonFun from '../assets/js/common.js'
import { mapMainUrl, uiMainUrl, mapConfigs, loadUIArr } from './config'
export default {
  data() {
    return {
      AMapUI: null,
      AMap: null,
      nLeft: 0,
      nTop: 0,
      markerIndex: '',
      moveCityCode: null,
      showDetails: false,
      markerId: ''
      // isShowHotCity: false //是否展示全国或者城市
    }
  },
  props: {
    isDblClickM: Boolean,
    isShowHotCity: Boolean,
    lnglats: {
      type: Array,
      default: () => {
        return []
      }
    },
    listDatas: {
      type: Array,
      default: () => {
        return []
      }
    },
    hCityDetails: {
      type: Array,
      default: () => {
        return []
      }
    },
    hotZoneAreas: {
      type: Array,
      default: () => {
        return []
      }
    },
    allData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    listDatas(val, oldVal) {
      if (val) {
        pathSimplifierIns.setData(this.changeLsData(val))
      }
    },
    lnglats(val, oldVal) {
      if (val) {
        showMarks()
      }
    },
    hotZoneAreas(val, oldVal) {
      if (val) {
        this.hotZoneAreas = val
      }
    },
    hCityDetails(val, oldVal) {
      if (val) {
        this.hCityDetails = val
        this.showDetails = true
      }
    }
  },
  methods: {
    showPosData(e, code) {
      this.nLeft = e.x
      this.nTop = e.y
      this.$emit('getHCityDetails', code)
    },
    closeDetails() {
      this.showDetails = false
    },
    goCity(code, name) {
      this.$router.push({
        path: '/roadOperation/hotCities',
        query: {
          id: 0,
          cityName: name,
          cityCode: code,
          isHotCity: true
        }
      })
    },
    changeLsData(listDatas) {
      var pathsData = []
      for (var v of listDatas) {
        if (v.paths.length > 0) {
          var pushId = v.paths
          if (pushId) {
            for (var i = 0; i < pushId.length; i++) {
              if (pushId[i].path.length == 0) {
                pushId.splice(i, 1)
                i = i - 1
              }
              pushId[i].id = v.id
              pushId[i].isShow = v.isShow
            }
            pathsData = pathsData.concat(pushId)
          }
        }
      }
      return commonFun.returnColor(pathsData)
    },
    // 添加或者编辑站点
    showNewPos(e, isAdd, obj) {
      this.$emit('showNewPos', e, isAdd, obj)
    },
    // 删除站点
    reMoveMark() {
      axios.deleteSide({ id: this.markerId }).then(e => {
        if (e.code == 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: e.message,
            type: 'warning'
          })
        }
      })
    },
    // 实例化地图
    initMap() {
      var _this = this
      let AMapUI = (this.AMapUI = window.AMapUI)
      let AMap = (this.AMap = window.AMap)
      AMapUI.load(loadUIArr, function(
        PathSimplifier,
        PositionPicker,
        DistrictExplorer,
        $
      ) {
        if (!PathSimplifier.supportCanvas) {
          alert('当前环境不支持 Canvas！')
          return
        }
        let mapConfig = mapConfigs
        var clickListener,
          map = new AMap.Map('js-container', mapConfig)
        // 显示站点
        var infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -30)
        })
        // 创建一个 Icon
        var startIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(20, 22),
          // 图标的取图地址
          image: require('./p.png'),
          // 图标所用图片大小
          imageSize: new AMap.Size(20, 22)
        })
        var markers = []
        showMarks()
        function showMarks() {
          var lnglats = _this.lnglats
          // map.clearMap()
          map.remove(markers)
          for (var i = 0, marker; i < lnglats.length; i++) {
            var marker = new AMap.Marker({
              position: lnglats[i].coordinateArr,
              map: map,
              cursor: 'pointer',
              zIndex: 100,
              icon: startIcon,
              offset: new AMap.Pixel(-10, -19),
              extData: {
                markIndex: i,
                id: lnglats[i].id,
                obj: lnglats[i]
              }
            })
            marker.content =
              '<div>集团：' +
              lnglats[i].companyName +
              '</div><div>位置：' +
              lnglats[i].cityName +
              '</div><div>销量：' +
              lnglats[i].sale +
              '</div><div>经纬度：' +
              lnglats[i].coordinateArr +
              '</div><div>备注：' +
              lnglats[i].remarks +
              '</div>'
            marker.on('click', markerClick)
            marker.on('mouseover', markerClick)
            marker.on('mouseout', markermouseout)
            marker.on('dblclick', markerEdit)
            //绑定鼠标右击事件——弹出右键菜单
            marker.on('rightclick', function(e) {
              _this.markerIndex = e.target.B.extData.markIndex
              _this.markerId = e.target.B.extData.id
              contextMenu.open(map, e.lnglat)
            })
            markers.push(marker)
          }
        }
        window.showMarks = showMarks
        //创建右键菜单
        var contextMenu = new AMap.ContextMenu()
        contextMenu.addItem(
          ' 删 除 ',
          function() {
            markers[_this.markerIndex].setMap(null)
            _this.reMoveMark()
          },
          0
        )
        function markerClick(e) {
          infoWindow.setContent(e.target.content)
          infoWindow.open(map, e.target.getPosition())
        }
        function markermouseout(e) {
          infoWindow.close(map, e.target.getPosition())
        }
        function markerEdit(e) {
          _this.isDblClickM = true
          var obj = e.target.B.extData.obj
          _this.showNewPos(e.pixel, false, obj)
        }
          // 监听地图点击事件
         clickListener = AMap.event.addListener(map, 'click', function(e) {
           console.log(e.lnglat)
         })
        // 监听地图双击事件
        clickListener = AMap.event.addListener(map, 'dblclick', function(e) {
          if (!_this.isDblClickM) {
            AMap.service('AMap.Geocoder', function() {
              //回调函数 实例化Geocoder 获取城市名称 创建站点
              var geocoder = new AMap.Geocoder({
                city: '' //城市，默认：“全国”
              })
              var cityName = ''
              var lnglatXY = [e.lnglat.getLng(), e.lnglat.getLat()] //地图上所标点的坐标
              geocoder.getAddress(lnglatXY, function(status, result) {
                if (status === 'complete' && result.info === 'OK') {
                  cityName = result.regeocode.addressComponent.city
                    ? result.regeocode.addressComponent.city
                    : result.regeocode.addressComponent.province
                  _this.showNewPos(e.pixel, true, {
                    coordinateX: e.lnglat.lng + ',' + e.lnglat.lat,
                    cityName: cityName,
                    cityCode: result.regeocode.addressComponent.citycode
                  })
                  var lnglats = _this.lnglats
                  lnglats.push({ coordinateArr: [e.lnglat.lng, e.lnglat.lat] })
                  _this.lnglats = lnglats
                  showMarks()
                } else {
                  console.log('获取失败')
                  //获取地址失败
                }
              })
            })
          }
        })
        //创建一个实例 热区面积
        var districtExplorer = new DistrictExplorer({
          eventSupport: true,
          map: map
        })
        //创建一个辅助Marker，提示鼠标内容
        var tipMarker = new AMap.Marker({
          //启用冒泡，否则click事件会被marker自己拦截
          bubble: true,
          icon: new AMap.Icon({
            image: null,
            size: new AMap.Size(0, 0), //图标大小
            imageSize: new AMap.Size(0, 0)
          })
        })
        //监听feature的hover事件
        districtExplorer.on(
          'featureMouseout featureMouseover featureClick',
          function(e, feature) {
            var isHover = e.type === 'featureMouseover'
            var isClick = e.type === 'featureClick'
            var isOut = e.type === 'featureMouseout'
            var props = feature.properties
            var polys = districtExplorer.findFeaturePolygonsByAdcode(
              props.acroutes[props.acroutes.length - 1]
            )
            if (!_this.isShowHotCity) {
              for (var i = 0, len = polys.length; i < len; i++) {
                polys[i].setOptions({
                  fillOpacity: isHover ? 1 : 0.6
                })
              }
            }
            // if (!isHover) {
            //   tipMarker.setMap(null)
            //   return
            // }
            // if (isHover) {
            //   tipMarker.setMap(map)
            //   tipMarker.setPosition(e.originalEvent.lnglat)
            //    tipMarker.setLabel({
            //     offset: new AMap.Pixel(-200, -120),
            //     bubble: false,
            //     content:'<div>运营次数：2340</div>'
            //   })
            // }

            if (!_this.isShowHotCity && isClick) {
              //  鼠标放上去获取热区详情
              // if (_this.moveCityCode != feature.properties.acroutes[1]) {
              var acroutes = feature.properties.acroutes
              //   _this.$emit('getHCityDetails', acroutes[acroutes.length - 1])
              // }
              // _this.moveCityCode = feature.properties.acroutes[1]
              // var hCityDetails = _this.hCityDetails
              _this.showPosData(
                e.originalEvent.pixel,
                acroutes[acroutes.length - 1]
              )
              // tipMarker.setLabel({
              //   offset: new AMap.Pixel(-200, -120),
              //   bubble: false,
              //   content:
              //     hCityDetails.length > 0
              //       ? '<div class="tipHover"><div class="th1">' +
              //         hCityDetails[0].cityName +
              //         ' <i class="el-icon-caret-right"><i class="el-icon-caret-right el-icon-caret-right1"></i></i><i class="el-icon-close el-icon-close12"></i></div>' +
              //         '<div class="th2"><div>' +
              //         hCityDetails[0].operations +
              //         ' <p>运营车次<br/>（日均）</p></div><div>' +
              //         hCityDetails[0].gasStation +
              //         ' <p>加油站停靠<br/>（日均）</p></div><div>' +
              //         hCityDetails[0].logisticsPark +
              //         ' <p>物流园停靠<br/>（日均）</p></div>' +
              //         '<div>' +
              //         hCityDetails[0].density +
              //         ' <p>加油站密度</p></div><div>' +
              //         hCityDetails[0].lugNumber +
              //         ' <p>LNG车次<br/>（日均）</p></div></div>' +
              //         '</div>'
              //       : null
              // })
            }
          }
        ) //feature被点击
        // districtExplorer.on('featureClick', function(e, feature) {
        //   var acroutes = feature.properties.acroutes
        //   var code = acroutes[acroutes.length - 1]
        //   AMap.service('AMap.Geocoder', function() {
        //     var geocoder = new AMap.Geocoder({
        //       city: '' //城市，默认：“全国”
        //     })
        //     var cityName = ''
        //     var lnglatXY = [
        //       e.originalEvent.lnglat.getLng(),
        //       e.originalEvent.lnglat.getLat()
        //     ] //地图上所标点的坐标
        //     geocoder.getAddress(lnglatXY, function(status, result) {
        //       if (status === 'complete' && result.info === 'OK') {
        //         cityName = result.regeocode.addressComponent.city
        //           ? result.regeocode.addressComponent.city
        //           : result.regeocode.addressComponent.province
        //         _this.goCity(code, cityName)
        //       } else {
        //         console.log('获取失败')
        //         //获取地址失败
        //       }
        //     })
        //   })
        // })
        function renderAreaNode(areaNode) {
          //绘制父区域
          districtExplorer.renderParentFeature(areaNode, {
            cursor: 'default',
            zIndex: 0,
            strokeColor: _this.isShowHotCity ? '#498AFF' : '#FFFFFF', //线颜色
            strokeOpacity: 0.3, //线透明度
            strokeWeight: 0.5, //线宽
            fillColor: _this.isShowHotCity
              ? '#498AFF'
              : getObjColor[areaNode.adcode], //填充色
            fillOpacity: _this.isShowHotCity ? 0.1 : 0.6 //填充透明度
          })
        }
        var adcodes = _this.adcodes,
          getObjColor = _this.getObjColor
        if (!_this.isShowHotCity) {
        }

        loadDatas(adcodes)
        function loadDatas(adcodes) {
          districtExplorer.loadMultiAreaNodes(adcodes, function(
            error,
            areaNodes
          ) {
            //设置定位节点，支持鼠标位置识别 注意节点的顺序，前面的高优先级
            districtExplorer.setAreaNodesForLocating(areaNodes)
            //清除已有的绘制内容
            // districtExplorer.clearFeaturePolygons()
            for (var i = 0, len = areaNodes.length; i < len; i++) {
              if (areaNodes[i]) {
                renderAreaNode(areaNodes[i])
              }
            }

            //更新地图视野
            map.setFitView(districtExplorer.getAllFeaturePolygons())
          })
        }
        window.loadDatas = loadDatas
        // return

        // 绘画道路
        var pathSimplifierIns = new PathSimplifier({
          zIndex: 100,
          // autoSetFitView: false,
          map: map, //所属的地图实例
          eventSupport: true,
          getPath: function(pathData, pathIndex) {
            return pathData.path
          },
          getHoverTitle: function(pathData, pathIndex, pointIndex) {
            var str = ''
            if (_this.isShowHotCity) {
              //  鼠标放上去获取热区详情
              _this.$emit('getHCityDetails', pathData.cityName)
              var hCityDetails = _this.hCityDetails
              str =
                '<div class="amap-marker-label"><div class="tipHover"><div class="th1">' +
                hCityDetails[0].highSpeedName +
                ' <i class="el-icon-caret-right"><i class="el-icon-caret-right el-icon-caret-right1"></i></i></div>' +
                '<div class="th2"><div>' +
                hCityDetails[0].operations +
                '<p>运营车次<br/>（日均）</p></div><div>' +
                hCityDetails[0].gasStation +
                '<p>加油站停靠<br/>（日均）</p></div><div>' +
                hCityDetails[0].logisticsPark +
                '<p>物流园停靠<br/>（日均）</p></div>' +
                '<div>' +
                hCityDetails[0].density +
                '<p>加油站密度</p></div><div>' +
                hCityDetails[0].lugNumber +
                '<p>LNG车次<br/>（日均）</p></div></div>' +
                '</div></div>'
            } else {
              str = '<div class="shown">运营车次：'+pathData.total+'</div>'
            }
            return str
          },
          renderOptions: {
            pathLineStyle: {
              dirArrowStyle: false
            },
            getPathStyle: function(pathItem, zoom) {
              var color = pathItem.pathData.color,
                i = pathItem.pathData.isShow ? 5 : 5,
                lineWidth = Math.round(i * Math.pow(1.1, zoom - 3))
              return {
                pathLineStyle: {
                  strokeStyle: color,
                  lineWidth: lineWidth,
                  borderStyle: null
                },
                startPointStyle: null,
                endPointStyle: null,
                pathLineHoverStyle: {
                  strokeStyle: color,
                  lineWidth: 6,
                  borderStyle: null,
                  dirArrowStyle: null
                },
                pathLineSelectedStyle: {
                  strokeStyle: color,
                  lineWidth: lineWidth,
                  borderStyle: null,
                  dirArrowStyle: null
                },
                pathNavigatorStyle: {
                  fillStyle: color
                }
              }
            }
          }
        })
        window.pathSimplifierIns = pathSimplifierIns
        var listDatas = _this.changeLsData(_this.listDatas)
        if (listDatas.length > 0) {
          pathSimplifierIns.setData(listDatas)
          pathSimplifierIns.on('pointClick pathClick', function(e, info) {
            // _this.$emit('changeLeftIndex', info.pathData.id)
          })
        } else {
          pathSimplifierIns.setData(null)
        }
      })
    }
  },
  async created() {
    var _this = this,
      hotZoneAreas = _this.hotZoneAreas,
      adcodess = [],
      arr = ['371200', '542400'],
      getObjColor = []
    getObjColor = commonFun.returnAreaColor(hotZoneAreas)
    _this.getObjColor = getObjColor
    for (var v of hotZoneAreas) {
      if (arr.indexOf(v.cityCode) == -1) {
        if (parseInt(v.cityCode)) {
          adcodess.push(parseInt(v.cityCode))
        }
      }
    }
    _this.adcodes = adcodess.splice(0, 25)
    var i = 1
    // var loadData = setInterval(function() {
    //   loadDatas(adcodess.splice(i * 25, 100), true)
    //   i++
    //   if (i == 12) {
    //     loadDatas(adcodess.splice(i * 25, adcodess.length - 1), true)
    //     clearInterval(loadData)
    //   }
    //   //  loadDatas(adcodess.splice(50,100),true)
    // }, 5000)
    // 已载入高德地图API，则直接初始化地图
    if (window.AMap && window.AMapUI) {
      this.initMap()
      // 未载入高德地图API，则先载入API再初始化
    } else {
      await remoteLoad(mapMainUrl)
      await remoteLoad(uiMainUrl)
      this.initMap()
    }
  }
}
</script>
<style>
.amap-ui-pathsimplifier-container .overlay-title:after,
.amap-ui-pathsimplifier-container .overlay-title:before {
  border: 0 !important;
  border-width: 0 !important;
}
.amap-ui-pathsimplifier-container .overlay-title {
  background: none !important;
  border: 0 !important;
}
.amap-vectors {
  z-index: 1 !important;
}
</style>

<style lang="css">
.m-map {
  min-width: 500px;
  min-height: 300px;
  overflow: hidden;
  background: #000000;
  position: relative;
}
.m-map .map {
  width: 100%;
  height: 100%;
}
.m-map .search {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 285px;
  z-index: 1;
}
.m-map .search input {
  width: 180px;
  border: 1px solid #ccc;
  line-height: 20px;
  padding: 5px;
  outline: none;
}
.m-map .search button {
  line-height: 26px;
  background: #fff;
  border: 1px solid #ccc;
  width: 50px;
  text-align: center;
}
.m-map .result {
  max-height: 300px;
  overflow: auto;
  margin-top: 10px;
}
.amap-info-sharp {
  display: none;
}
.btn:hover {
  cursor: pointer;
}
.m-tip {
  font-size: 18px;
  color: #fff;
  position: absolute;
  top: 70px;
  z-index: 9000;
  left: 340px;
}
.amap-info-content {
  background: #006cdf;
  color: #fff;
  font-size: 10px;
}
.tipHover {
  width: 450px;
  padding: 20px 10px;
  padding-bottom: 0;
  z-index: 9001;
  position: relative;
}
.tipHover .el-icon-caret-right {
  position: relative;
  color: #03dd94;
}
.tipHover .el-icon-caret-right1 {
  position: absolute;
  left: 10px;
}
.amap-marker-label {
  background-color: unset;
  z-index: 9001;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
}
.shown{
  color: #fff
}
.th1 {
  font-size: 18px;
  padding-left: 10px;
  color: #ffffff;
  font-weight: bold;
}
.th1 span:hover {
  cursor: pointer;
}
.th2 {
  font-size: 10px;
  margin-top: 13px;
  color: #ffffff;
}
.th2 > div {
  display: inline-block;
  width: 20%;
  vertical-align: top;
  text-align: center;
}
.th2 > div p {
  font-size: 10px;
  margin-top: 8px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.5);
}
.m-font0 {
  font-size: 12px;
  color: #fff;
  position: absolute;
  top: 110px;
  z-index: 9000;
  left: 300px;
}
.m-font0 span {
  color: #498aff;
}
.el-icon-close12 {
  font-size: 20px;
  font-weight: bold;
  margin-top: -4px;
  float: right;
}
.el-icon-close12:hover {
  cursor: pointer;
}
</style>